<template>
  <section>
    <div
      class="container"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <div>
        <HeaderDateil></HeaderDateil>
      </div>
      <div class="paperdetail">
        <div
          style="text-align: center; font-size: 30px; font-weight: bold;padding-top: 20px;"
        >{{ ExamDetail.title }}</div>
        <div style="display: flex; padding-top: 20px">

          <div style="padding-left: 30%; font-size: 18px;">
            <span style="font-weight: bold">主办单位：</span>
            <span style="width: 300px;display: inline-block;">{{ExamDetail.deptName}}</span>
          </div>
          <div style="padding-left: 1%; font-size: 18px;">
            <span style="font-weight: bold">考试科目：</span>
            <span style="width: 200px;display: inline-block;">{{ExamDetail.subjectName}}</span>
          </div>
          <div style="padding-left: 1%; font-size: 18px;">
             <span style="font-weight: bold">姓名：</span>
            <span style="width: 160px;display: inline-block;">{{userName}}</span>
          </div>
          
        </div>
        <div
          class="test-description"
          v-if="ExamDetail.description"
        ><span style="font-weight: bold">考试说明：</span>{{ ExamDetail.description }}</div>
      </div>
      <div class="zhuti">
        <div class="title" v-if="dxt != 0">
          <span style="padding-left: 30px">单选题</span>
          <span style="padding-left: 10px">(共 {{ dxt }} 题，合计 {{ dxtSum.toFixed(2) }} 分)</span>
        </div>
        <div v-for="(item, index) in abc" :key="index" v-if="item.type == 1">
          <div class="hhh">
            <div class="sss">
              <!-- 题目展示 -->
              <div class="subject">
                <span class="padding-r5">{{ index + 1 }}.</span>
                <span v-html="item.title" :id="item.id"></span>
              </div>
              <div @click="getId(abc[index].id)" style="diaplay: flex; width: 50px;">
                <el-popover
                  placement="bottom-end"
                  width="400"
                  v-model="item.visible"
                  trigger="click"
                >
                  <el-form :model="temp" label-position="right" label-width="100px">
                    <el-form-item size="small" :label="'问题类型：'" prop="typeDicId" required>
                      <el-radio-group v-model="temp.typeDicId">
                        <el-radio :label="1">题目不完整</el-radio>
                        <el-radio :label="2">答案不正确</el-radio>
                        <el-radio :label="3">含有错别字</el-radio>
                        <el-radio :label="4">图片不存在</el-radio>
                        <el-radio :label="5">解析不完整</el-radio>
                        <el-radio :label="6">其他错误</el-radio>
                      </el-radio-group>
                    </el-form-item>

                    <el-form-item size="small" :label="'意见：'" prop="idea">
                      <el-input v-model="temp.idea" type="textarea"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="text-align: right; margin: 0">
                    <el-button type="primary" size="mini" @click="submitWrong(item)">确定</el-button>
                  </div>
                  <i
                    class="el-icon-question"
                    style="color: red;margin-right: 10px;font-size: 16px;"
                    slot="reference"
                    title="题目反馈"
                    ref="wrongRef"
                  ></i>
                </el-popover>
                <i
                  v-if="item.bjStatus == true"
                  class="iconfont icon-qizi-copy"
                  @click="biaoji(item, index)"
                ></i>
                <i v-else class="iconfont icon-qizi" @click="biaoji(item, index)"></i>
              </div>
              <!-- <div>
                <el-tooltip class="item" effect="dark" content="取消标记" placement="top">
                  <svg v-if="item.bjStatus == true" class="icon" @click="biaoji(item, index)">
                    <use xlink:href="#iconbiaoji" />
                  </svg>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="标记" placement="top">
                  <svg v-if="item.bjStatus == false" class="icon" @click="biaoji(item, index)">
                    <use xlink:href="#iconmark" />
                  </svg>
                </el-tooltip>
              </div>-->
            </div>
            <!-- 选择区域 -->
            <div class="select-box">
              <ul>
                <li
                  v-for="(items, indexs) in item.answer"
                  :key="indexs"
                  @click="radioChange(index, indexs, item)"
                >
                  <label :for="item.Id" class="xz-label">
                    <input
                      type="radio"
                      v-model="item.value"
                      :value="items.Id"
                      @change="radioChange(index, indexs, item)"
                      :id="item.Id"
                      style=" margin-right: 10px;"
                    />
                    <span
                      style="text-index: -2em;padding-right: 5px;"
                    >{{String.fromCharCode(64 + parseInt(indexs+1))}}.</span>
                    {{ items.Name }}
                  </label>
                </li>
              </ul>
            </div>
            <div class="answer" v-if="Status == true">
              <div v-for="(items, indexs) in item.answer" :key="indexs" :id="items.Name">
                <span v-if="indexs == 0 && items.IsRight == true">正确答案：A</span>
                <span v-if="indexs == 1 && items.IsRight == true">正确答案：B</span>
                <span v-if="indexs == 2 && items.IsRight == true">正确答案：C</span>
                <span v-if="indexs == 3 && items.IsRight == true">正确答案：D</span>
                <span v-if="indexs == 4 && items.IsRight == true">正确答案：E</span>
                <span v-if="indexs == 5 && items.IsRight == true">正确答案：F</span>
                <span v-if="indexs == 6 && items.IsRight == true">正确答案：G</span>
                <span v-if="indexs == 7 && items.IsRight == true">正确答案：H</span>
                <span v-if="indexs == 0 && items.IsCheck == true">选择的答案：A</span>
                <span v-if="indexs == 1 && items.IsCheck == true">选择的答案：B</span>
                <span v-if="indexs == 2 && items.IsCheck == true">选择的答案：C</span>
                <span v-if="indexs == 3 && items.IsCheck == true">选择的答案：D</span>
                <span v-if="indexs == 4 && items.IsCheck == true">选择的答案：E</span>
                <span v-if="indexs == 5 && items.IsCheck == true">选择的答案：F</span>
                <span v-if="indexs == 6 && items.IsCheck == true">选择的答案：G</span>
                <span v-if="indexs == 7 && items.IsCheck == true">选择的答案：H</span>
              </div>
              <div style="margin-left: 40px">
                <span v-if="item.value == ''">你选择的答案：未作答</span>
              </div>
              <div style="margin-left: 62%; color: #1b89ce">
                <span v-if="item.level == 127">难易度：易</span>
                <span v-if="item.level == 128">难易度：较易</span>
                <span v-if="item.level == 129">难易度：一般</span>
                <span v-if="item.level == 130">难易度：较难</span>
                <span v-if="item.level == 131">难易度：难</span>
              </div>
            </div>
            <div class="analysis" v-if="Status == true">
              <span>解析：{{ item.explain }}</span>
            </div>
          </div>
        </div>
        <div class="title" v-if="ddxt != 0">
          <span style="padding-left: 30px">多选题</span>
          <span style="padding-left: 10px">(共 {{ ddxt }} 题，合计 {{ ddxtSum.toFixed(2) }} 分)</span>
        </div>
        <div v-for="(item, index1) in abc" :key="index1" v-if="item.type == 2">
          <div class="hhh">
            <div class="sss">
              <!-- <div :id="item.title">{{ index1 + 1 }}.{{ item.title }}</div> -->
              <div class="subject">
                <span class="padding-r5">{{ index1 + 1 }}.</span>
                <span v-html="item.title" :id="item.id"></span>
              </div>
              <!-- <div>
                  <i v-if="item.bjStatus == true"  class="iconfont icon-qizi-copy" @click="biaoji(item, index1)"></i>
                  <i  v-else class="iconfont icon-qizi" @click="biaoji(item, index1)"></i>
              </div>-->
              <div @click="getId(abc[index1].id)" style="display: flex; width: 50px;">
                <el-popover
                  placement="bottom-end"
                  width="400"
                  v-model="item.visible"
                  trigger="click"
                >
                  <el-form :model="temp" label-position="right" label-width="100px">
                    <el-form-item size="small" :label="'问题类型：'" prop="typeDicId" required>
                      <el-radio-group v-model="temp.typeDicId">
                        <el-radio :label="1">题目不完整</el-radio>
                        <el-radio :label="2">答案不正确</el-radio>
                        <el-radio :label="3">含有错别字</el-radio>
                        <el-radio :label="4">图片不存在</el-radio>
                        <el-radio :label="5">解析不完整</el-radio>
                        <el-radio :label="6">其他错误</el-radio>
                      </el-radio-group>
                    </el-form-item>

                    <el-form-item size="small" :label="'意见：'" prop="idea">
                      <el-input v-model="temp.idea" type="textarea"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="text-align: right; margin: 0">
                    <el-button type="primary" size="mini" @click="submitWrong(item)">确定</el-button>
                  </div>
                  <i
                    class="el-icon-question"
                    style="color: red;margin-right: 10px;"
                    slot="reference"
                    title="题目反馈"
                    ref="wrongRef"
                  ></i>
                </el-popover>
                <i
                  v-if="item.bjStatus == true"
                  class="iconfont icon-qizi-copy"
                  @click="biaoji(item, index1)"
                ></i>
                <i v-else class="iconfont icon-qizi" @click="biaoji(item, index1)"></i>
              </div>
            </div>
            <div class="select-box">
              <ul>
                <li v-for="(items, indexs1) in item.answer" :key="indexs1" :id="items.Name">
                  <label :for="item.Id" class="xz-label">
                    <input
                      type="checkbox"
                      v-model="items.IsCheck"
                      :value="items.Id"
                      @change="checkboxChange(index1, indexs1, item)"
                      style="margin-right: 10px;"
                      :id="item.Id"
                    />
                    <span
                      style="text-index: -2em;padding-right: 5px;"
                    >{{String.fromCharCode(64 + parseInt(indexs1+1))}}.</span>
                    {{items.Name}}
                  </label>
                </li>
              </ul>
            </div>
            <div class="answer" v-if="Status == true">
              <div class="rightanswer">
                <div>正确答案：</div>
                <div v-for="(items, indexs) in item.answer" :key="indexs">
                  <span v-if="indexs == 0 && items.IsRight == true">A</span>
                  <span v-if="indexs == 1 && items.IsRight == true">B</span>
                  <span v-if="indexs == 2 && items.IsRight == true">C</span>
                  <span v-if="indexs == 3 && items.IsRight == true">D</span>
                  <span v-if="indexs == 4 && items.IsRight == true">E</span>
                  <span v-if="indexs == 5 && items.IsRight == true">F</span>
                  <span v-if="indexs == 6 && items.IsRight == true">G</span>
                  <span v-if="indexs == 7 && items.IsRight == true">H</span>
                </div>
              </div>
              <div class="mychange">
                <div v-if="item.MyCate != ''">选择的答案：</div>
                <div v-for="(aaa, bbb) in item.CheckAnswer" :key="bbb">
                  <span v-if="aaa.Value == 1">A</span>
                  <span v-if="aaa.Value == 2">B</span>
                  <span v-if="aaa.Value == 3">C</span>
                  <span v-if="aaa.Value == 4">D</span>
                  <span v-if="aaa.Value == 5">E</span>
                  <span v-if="aaa.Value == 6">F</span>
                  <span v-if="aaa.Value == 7">G</span>
                  <span v-if="aaa.Value == 8">H</span>
                </div>
              </div>
              <div class="mychange" v-if="item.MyCate == ''">
                <span>我选择的答案：未作答</span>
              </div>
              <div style="margin-left: 30%; color: #1b89ce">
                <span v-if="item.level == 127">难易度：易</span>
                <span v-if="item.level == 128">难易度：较易</span>
                <span v-if="item.level == 129">难易度：一般</span>
                <span v-if="item.level == 130">难易度：较难</span>
                <span v-if="item.level == 131">难易度：难</span>
              </div>
            </div>
            <div class="analysis" v-if="Status == true">
              >
              <span>解析：{{ item.explain }}</span>
            </div>
          </div>
        </div>
        <div class="title" v-if="pdt != 0">
          <span style="padding-left: 30px">判断题</span>
          <span style="padding-left: 10px">(共 {{ pdt }} 题，合计 {{ pdtSum.toFixed(2) }} 分)</span>
        </div>
        <div v-for="(item, index2) in abc" :key="index2" v-if="item.type == 3">
          <div class="hhh">
            <div class="sss">
              <!-- <div :id="item.title">{{ index2 + 1 }}.{{ item.title }}</div> -->
              <div class="subject">
                <span class="padding-r5">{{ index2 + 1 }}.</span>
                <span v-html="item.title" :id="item.id"></span>
              </div>
              <!-- <div>
                  <i v-if="item.bjStatus == true"  class="iconfont icon-qizi-copy" @click="biaoji(item, index2)"></i>
                  <i  v-else class="iconfont icon-qizi" @click="biaoji(item, index2)"></i>
              </div>-->
              <div @click="getId(abc[index2].id)" style="display: flex; width: 50px;">
                <el-popover
                  placement="bottom-end"
                  width="400"
                  v-model="item.visible"
                  trigger="click"
                >
                  <el-form :model="temp" label-position="right" label-width="100px">
                    <el-form-item size="small" :label="'问题类型：'" prop="typeDicId" required>
                      <el-radio-group v-model="temp.typeDicId">
                        <el-radio :label="1">题目不完整</el-radio>
                        <el-radio :label="2">答案不正确</el-radio>
                        <el-radio :label="3">含有错别字</el-radio>
                        <el-radio :label="4">图片不存在</el-radio>
                        <el-radio :label="5">解析不完整</el-radio>
                        <el-radio :label="6">其他错误</el-radio>
                      </el-radio-group>
                    </el-form-item>

                    <el-form-item size="small" :label="'意见：'" prop="idea">
                      <el-input v-model="temp.idea" type="textarea"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="text-align: right; margin: 0">
                    <el-button type="primary" size="mini" @click="submitWrong(item)">确定</el-button>
                  </div>
                  <i
                    class="el-icon-question"
                    style="color: red;margin-right: 10px;"
                    slot="reference"
                    title="题目反馈"
                    ref="wrongRef"
                  ></i>
                </el-popover>
                <i
                  v-if="item.bjStatus == true"
                  class="iconfont icon-qizi-copy"
                  @click="biaoji(item, index2)"
                ></i>
                <i v-else class="iconfont icon-qizi" @click="biaoji(item, index2)"></i>
              </div>
            </div>
            <div class="select-box" style="padding-left: 35px;">
              <label :for="item.Id" class="xz-label">
                <input
                  :id="item.Id"
                  :name="item.id"
                  type="radio"
                  :checked="item.IsCheck==true"
                  @change="dui(index2, item)"
                  style="margin-right: 10px"
                />
                正确
              </label>

              <label class="xz-label" :for="item.Id">
                <input
                  :id="item.Id"
                  :name="item.id"
                  :checked="item.IsCheck==false"
                  type="radio"
                  @change="cuo(index2, item)"
                  style="margin-right: 10px"
                />
                错误
              </label>
            </div>
            <div class="answer" v-if="Status == true">
              >
              <div v-for="(items, indexs) in item.answer" :key="indexs" :id="items.Name">
                <span v-if="items.IsRight == true">正确答案：正确</span>
                <span v-if="items.IsRight == false">正确答案：错误</span>
              </div>
              <div style="margin-left: 40px">
                <span v-if="item.value == ''">选择的答案：未作答</span>
              </div>
              <div style="margin-left: 60%; color: #1b89ce">
                <span v-if="item.level == 127">难易度：易</span>
                <span v-if="item.level == 128">难易度：较易</span>
                <span v-if="item.level == 129">难易度：一般</span>
                <span v-if="item.level == 130">难易度：较难</span>
                <span v-if="item.level == 131">难易度：难</span>
              </div>
            </div>
            <div class="analysis" v-if="Status == true">
              >
              <span>解析：{{ item.explain }}</span>
            </div>
          </div>
        </div>
        <div class="title" v-if="tkt != 0">
          <span style="padding-left: 30px">填空题</span>
          <span style="padding-left: 10px">(共 {{ tkt }} 题，合计 {{ tktSum.toFixed(2) }} 分)</span>
        </div>
        <div v-for="(item, index4) in abc" :key="index4" v-if="item.type == 4">
          <div class="hhh">
            <div class="sss">
              <!-- <div :id="item.title">{{ index4 + 1 }}.{{ item.title }}</div> -->
              <div class="subject">
                <span class="padding-r5">{{ index4 + 1 }}.</span>
                <span v-html="item.title" :id="item.id"></span>
              </div>
              <!-- <div>
                  <i v-if="item.bjStatus == true"  class="iconfont icon-qizi-copy" @click="biaoji(item, index4)"></i>
                  <i  v-else class="iconfont icon-qizi" @click="biaoji(item, index4)"></i>
              </div>-->
              <div @click="getId(abc[index4].id)" style="display: flex; width: 50px;">
                <el-popover
                  placement="bottom-end"
                  width="400"
                  v-model="item.visible"
                  trigger="click"
                >
                  <el-form :model="temp" label-position="right" label-width="100px">
                    <el-form-item size="small" :label="'问题类型：'" prop="typeDicId" required>
                      <el-radio-group v-model="temp.typeDicId">
                        <el-radio :label="1">题目不完整</el-radio>
                        <el-radio :label="2">答案不正确</el-radio>
                        <el-radio :label="3">含有错别字</el-radio>
                        <el-radio :label="4">图片不存在</el-radio>
                        <el-radio :label="5">解析不完整</el-radio>
                        <el-radio :label="6">其他错误</el-radio>
                      </el-radio-group>
                    </el-form-item>

                    <el-form-item size="small" :label="'意见：'" prop="idea">
                      <el-input v-model="temp.idea" type="textarea"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="text-align: right; margin: 0">
                    <el-button type="primary" size="mini" @click="submitWrong(item)">确定</el-button>
                  </div>
                  <i
                    class="el-icon-question"
                    style="color: red;margin-right: 10px;"
                    slot="reference"
                    title="题目反馈"
                    ref="wrongRef"
                  ></i>
                </el-popover>
                <i
                  v-if="item.bjStatus == true"
                  class="iconfont icon-qizi-copy"
                  @click="biaoji(item, index4)"
                ></i>
                <i v-else class="iconfont icon-qizi" @click="biaoji(item, index4)"></i>
              </div>
            </div>
            <div class="select-box">
              <el-input
                v-for="(items, indexs2) in item.answer"
                @paste.native.capture.prevent="handlePaste"
                :key="indexs2"
                v-model="items.letter"
                v-on:input="inputChange(index4, indexs2, item)"
                placeholder="请输入内容"
                style="
                  width: 95%;
                  padding-left: 30px;
                  padding-top: 10px;
                  padding-bottom: 10px;
                "
              >
                <template slot="prepend">{{ indexs2 + 1 }}</template>
              </el-input>
            </div>
            <div class="answer" v-if="Status == true">
              <div
                v-for="(items, indexs) in item.answer"
                :key="indexs"
                :id="items.Name"
                style="width: 40%"
              >
                <span>正确答案：{{ item.Name }}</span>
              </div>
              <div style="margin-left: 50%; color: #1b89ce">
                <span v-if="item.level == 127">难易度：易</span>
                <span v-if="item.level == 128">难易度：较易</span>
                <span v-if="item.level == 129">难易度：一般</span>
                <span v-if="item.level == 130">难易度：较难</span>
                <span v-if="item.level == 131">难易度：难</span>
              </div>
            </div>
            <div class="analysis" v-if="Status == true">
              <span>解析：{{ item.explain }}</span>
            </div>
          </div>
        </div>
        <div class="title" v-if="wdt != 0">
          <span style="padding-left: 30px">问答题</span>
          <span style="padding-left: 10px">(共 {{ wdt }} 题，合计 {{ wdtSum.toFixed(2) }} 分)</span>
        </div>
        <div v-for="(item, index3) in abc" :key="index3" v-if="item.type == 5">
          <div class="hhh">
            <div class="sss">
              <div class="subject">
                <span class="padding-r5">{{ index3 + 1 }}.</span>
                <span v-html="item.title" :id="item.id"></span>
              </div>
              <!-- <div>
                  <i v-if="item.bjStatus == true"  class="iconfont icon-qizi-copy" @click="biaoji(item, index3)"></i>
                  <i  v-else class="iconfont icon-qizi" @click="biaoji(item, index3)"></i>
              </div>-->
              <div @click="getId(abc[index3].id)" style="display: flex; width: 50px;">
                <el-popover
                  placement="bottom-end"
                  width="400"
                  v-model="item.visible"
                  trigger="click"
                >
                  <el-form :model="temp" label-position="right" label-width="100px">
                    <el-form-item size="small" :label="'问题类型：'" prop="typeDicId" required>
                      <el-radio-group v-model="temp.typeDicId">
                        <el-radio :label="1">题目不完整</el-radio>
                        <el-radio :label="2">答案不正确</el-radio>
                        <el-radio :label="3">含有错别字</el-radio>
                        <el-radio :label="4">图片不存在</el-radio>
                        <el-radio :label="5">解析不完整</el-radio>
                        <el-radio :label="6">其他错误</el-radio>
                      </el-radio-group>
                    </el-form-item>

                    <el-form-item size="small" :label="'意见：'" prop="idea">
                      <el-input v-model="temp.idea" type="textarea"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="text-align: right; margin: 0">
                    <el-button type="primary" size="mini" @click="submitWrong(item)">确定</el-button>
                  </div>
                  <i
                    class="el-icon-question"
                    style="color: red;margin-right: 10px;"
                    slot="reference"
                    title="题目反馈"
                    ref="wrongRef"
                  ></i>
                </el-popover>
                <i
                  v-if="item.bjStatus == true"
                  class="iconfont icon-qizi-copy"
                  @click="biaoji(item, index3)"
                ></i>
                <i v-else class="iconfont icon-qizi" @click="biaoji(item, index3)"></i>
              </div>
            </div>
            <div class="select-box">
              <el-input
                v-for="(items, indexs2) in item.answer"
                @paste.native.capture.prevent="handlePaste"
                :key="indexs2"
                v-model="items.letter"
                type="textarea"
                :rows="4"
                v-on:input="inputChange(index3, indexs2, item)"
                placeholder="请输入内容"
                style="
                  width: 95%;
                  padding-left: 30px;
                  padding-top: 10px;
                  padding-bottom: 20px;
                "
              ></el-input>
            </div>
            <div class="answer" v-if="item.Status==true">
              <div
                v-for="(items, indexs) in item.answer"
                :key="indexs"
                :id="items.Name"
                class="right-key"
              >
                <span class="select-keys">正确答案：{{ items.Name }}</span>
                <span class="tx-keys">
                  填写的答案：{{
                  items.letter == "" ? "无" : items.letter
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="title" v-if="sct!= 0">
          <span style="padding-left: 30px">实操题</span>
          <span style="padding-left: 10px">(共 {{ sct }} 题，合计 {{ sctSum.toFixed(2) }} 分)</span>
        </div>
        <div v-for="(item, index6) in abc" :key="index6" v-if="item.type == 6">
          <div class="hhh">
            <div class="sss">
              <div class="subject">
                <span class="padding-r5">{{ index6 + 1 }}.</span>
                <span v-html="item.title" :id="item.id"></span>
              </div>
              <div @click="getId(abc[index6].id)" style="display: flex; width: 50px;">
                <el-popover
                  placement="bottom-end"
                  width="400"
                  v-model="item.visible"
                  trigger="click"
                >
                  <el-form :model="temp" label-position="right" label-width="100px">
                    <el-form-item size="small" :label="'问题类型：'" prop="typeDicId" required>
                      <el-radio-group v-model="temp.typeDicId">
                        <el-radio :label="1">题目不完整</el-radio>
                        <el-radio :label="2">答案不正确</el-radio>
                        <el-radio :label="3">含有错别字</el-radio>
                        <el-radio :label="4">图片不存在</el-radio>
                        <el-radio :label="5">解析不完整</el-radio>
                        <el-radio :label="6">其他错误</el-radio>
                      </el-radio-group>
                    </el-form-item>

                    <el-form-item size="small" :label="'意见：'" prop="idea">
                      <el-input v-model="temp.idea" type="textarea"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="text-align: right; margin: 0">
                    <el-button type="primary" size="mini" @click="submitWrong(item)">确定</el-button>
                  </div>
                  <i
                    class="el-icon-question"
                    style="color: red;margin-right: 10px;"
                    slot="reference"
                    title="题目反馈"
                    ref="wrongRef"
                  ></i>
                </el-popover>
                <i
                  v-if="item.bjStatus == true"
                  class="iconfont icon-qizi-copy"
                  title="标记"
                  @click="biaoji(item, index6)"
                ></i>
                <i v-else class="iconfont icon-qizi" @click="biaoji(item, index6)"></i>
              </div>
            </div>
            <div class="rules-box">
              <el-input
                :value="item.rules"
                placeholder="答题要求："
                type="textarea"
                rows="8"
                style="
                  width: 95%;
                  padding-left: 30px;
                  padding-bottom: 20px;
                "
              ></el-input>
            </div>
            <div class="goscExam">
              <el-button
                type="primary"
                @click="EnterPaper(item,index6)"
                style="width: 300px;margin-bottom: 10px;"
              >进入实操考试</el-button>
              <span style="font-size: 14px">
                <span style="color:red;">注意：</span> 若无法进入实操考试，请确认是否已安装实操考试插件；安转插件请点击下方插件名称
              </span>
              <el-link type="primary" href="/uploadfile/xtaddin_v1.1.rar">xtaddin_v1.1.rar</el-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 答题卡 -->
      <div>
        <left :class="[fix == true ? 'fixed' : 'leftzj']" ref="left" :questionList="questionList" v-if="questionList"></left>
      </div>
      <div :class="[fix == true ? 'paper-fixed' : 'paper-box']">
        <!-- <div class="paper-time">
          <span>剩余时间</span>
          <span class="red-color">{{ hr }}:{{ mins }}:{{ sec }}</span>
        </div> -->
        <div class="paper-progress">
          <span>当前进度</span>
          <div class="speed-box">
            <span class="speed">{{speedNum}}</span>
            <span>/</span>
            <span class="speed">{{allSum}}</span>
          </div>
          <el-progress
            style="width: 80px;"
            :show-text="false"
            :percentage="paperPercentage"
            :color="customColor"
          ></el-progress>
        </div>
        <div class="tj">
          <el-button type="primary" @click="btnSubmit">提交</el-button>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="progress" v-if="show">
        <div style="margin-top: 40px">
          交卷中
          <span id="a" style="display: none">.</span>
          <span id="b" style="display: none">.</span>
          <span id="c" style="display: none">.</span>
        </div>
        <div style="margin-top: 20px">
          <el-progress type="circle" :color="customColors" :percentage="percentage"></el-progress>
        </div>
        <div>
          <span v-if="this.percentage <= 25" style="font-size: 10px; color: gray">正在提交答案...</span>
          <span v-if="percentage <= 25" style="font-size: 10px; color: gray">正在提交答案...</span>
          <span
            v-if="percentage < 50 && percentage > 25"
            style="font-size: 10px; color: gray"
          >正在判分中...</span>
          <span
            v-if="percentage > 50 && percentage < 75"
            style="font-size: 10px; color: gray"
          >正在出分中...</span>
          <span
            v-if="percentage > 75"
            style="padding-left: 10px; font-size: 10px; color: gray"
          >正在改卷，请稍等！</span>
        </div>
      </div>
    </transition>
    <el-dialog :visible.sync="submitDialogVisible" :show-close="false" width="30%">
      <span class="title-info">{{inforText}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="Submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible1"
      :close-on-click-modal="false"
      width="400px"
      :show-close="false"
      style="margin-top: 10%"
      center
    >
      <div class="cheat-box">
        <div class="cheat-title">考试成绩</div>
        <div class="cheat-container">
          <div class="cheat-beizhu">
            <span class="cheat-beizhu-weight">{{totalScore.toFixed(2)}} 分</span>
          </div>
        </div>
        <div class="cheat-button">
          <el-button type="primary" size="mini" @click="btnSelect">查看试卷</el-button>
        </div>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import vHeader from '../../header/index';
import left from '../paper/left';
import * as pmiDictionary from '@/api/pmi/dictionarys';
import * as pmiDept from '@/api/pmi/dept';
import {
  SelectPaperQuestion,
  SelectPaperDetail,
  SelectPointExam,
  EnterPaper,
  SelectQuestion,
  addQuest,
  GetDetailLx
} from '@/api/exam/paper';
import HeaderDateil from '@/components/headerDateil';
import * as Exam from '@/api/exam/exam';
import { getInfo} from '@/utils/auth';
export default {
  components: {
    vHeader,
    left,
    HeaderDateil,
  },
  data() {
    return {
      visible: false,
      subjectList: [],
      deptList: [],
      //弹框提示信息
      inforText: '',
      //提交弹框的显示和隐藏
      submitDialogVisible: false,
      jindu: '',
      zongjindu: '',
      abc: [],
      dxt: 0,
      dxtSum: 0,
      tkt: 0,
      tktSum: 0,
      pdt: 0,
      pdtSum: 0,
      wdt: 0,
      wdtSum: 0,
      ddxt: 0,
      ddxtSum: 0,
      sct: 0,
      sctSum: 0,
      allSum: 0,
      Status: false,
      paperId: localStorage.getItem('paperId'),
      Id: localStorage.getItem('Id'),
      fix: false,
      PaperDetail: [],
      ExamDetail: [],
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: true,
      date: null,
      ExamStatus: true,
      loading: true, //遮罩层
      percentage: 0, //进度条进度
      customColors: [
        //进度条颜色变化
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#6f7ad3', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#5cb87a', percentage: 100 },
      ],
      show: false, //vue动画加载
      hr: 0,
      mins: 0,
      sec: 0,
      customColor: '#409eff',
      paperPercentage: 0,
      speedNum: 0, //进度
      temp: {
        questionId: 0,
        typeDicId: null,
        idea: '',
        status: 0,
        createId: 0,
      },
      visible: false,
      userName: '无',
      deptName: '无',
      urlA: '',
      userId: 0,
      enterPaperId: 0,
      totalScore: 0,
      questionList:null,
    };
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem('oldtimes');
    next();
  },

  methods: {
    //查看已经考试的页面
    btnSelect() {
      sessionStorage.setItem('tijiao', true);
      this.$router.replace({
        path: '/subMulationExam',
        query: { processId:this.enterPaperId,examId:this.Id },
      });
    },
    //进入考试页面
    EnterPaper(item, index) {
      this.abc[index].MyCate = true;
      this.$refs.left.Selected(index, 0, item);
      let para = {
        examId: this.Id,
        questionId: item.id,
        userId: JSON.parse(getInfo('infos')).id,
      };
      Exam.getShiCaoUrlNew(para).then((res) => {
        this.urlA = res.result;
        window.location.href = this.urlA;
      });
    },
    getId(id) {
      this.temp = {
        questionId: id,
        typeDicId: null,
        idea: '',
        status: 0,
        createId: JSON.parse(getInfo('infos')).id ? JSON.parse(getInfo('infos')).id : 0,
      };
    },
    submitWrong(item) {
      if (this.temp.typeDicId == null) {
        this.$message({
          message: '请选择问题类型',
          type: 'warning',
        });
        return false;
      }
      let para = this.temp;
      addQuest(para).then((res) => {
        if (res.code == 200) {
          this.$message.success('反馈成功！');
          item.visible = false;
        }
      });
    },
    //获取所有科目
    getSubjectList() {
      let _this = this;
      let data = { NamespaceId: 6 };
      pmiDictionary.getList(data).then((res) => {
        res.data.forEach(function (item, index) {
          let modeInfo = {};
          modeInfo.value = item.id;
          modeInfo.label = item.name;
          _this.subjectList.push(modeInfo);
        });
      });
    },
    //获取所有部门
    getCateList() {
      let _this = this;
      let para = {
        Page: 1,
        Limit: 100,
      };
      pmiDept.getList(para).then((res) => {
        res.data.forEach(function (item, index) {
          let modeInfo = {};
          modeInfo.value = item.id;
          modeInfo.label = item.name;
          _this.deptList.push(modeInfo);
        });
      });
    },
    paperTime() {
      let times = Date.parse(new Date()); //当前时间，本来应该由后台传回服务器时间，但是后台没有传，暂时已浏览器本机时间来计算
      let oldtimes = 0;
      let haoshi = 0;
      let expires = this.ExamDetail.times * 60 * 1000; //有效时长，默认是10分钟，本来应该由后台给出，但是后台没给，暂时写死
      if (!localStorage.getItem('oldtimes')) {
        oldtimes = localStorage.setItem('oldtimes', times);
      } else {
        oldtimes = localStorage.getItem('oldtimes');
        haoshi = times - oldtimes;
        expires = expires - haoshi;
      }

      this.hr = parseInt((expires / 1000 / 60 / 60) % 24); //时
      this.mins = parseInt((expires / 1000 / 60) % 60); //分
      this.sec = parseInt((expires / 1000) % 60); //秒
      if (this.hr < 10) {
        this.hr = '0' + this.hr;
      }
      if (this.mins < 10) {
        this.mins = '0' + this.mins;
      }
      if (this.sec < 10) {
        this.sec = '0' + this.sec;
      }
      if (this.sec <= 0) {
        this.sec = '0' + 0;
      }
      this.interval = setInterval(() => {
        if (expires > 0) {
          expires = expires - 1000;
        }
        this.hr = parseInt((expires / 1000 / 60 / 60) % 24); //时
        this.mins = parseInt((expires / 1000 / 60) % 60); //分
        this.sec = parseInt((expires / 1000) % 60); //秒
        if (this.hr < 10) {
          this.hr = '0' + this.hr;
        }
        if (this.mins < 10) {
          this.mins = '0' + this.mins;
        }
        if (this.sec < 10) {
          this.sec = '0' + this.sec;
        }
        if (expires == 0) {
          clearInterval(this.interval);
          this.Submit();
        }
      }, 1000);
    },
    //点击提交按钮
    btnSubmit() {
      this.submitDialogVisible = true;
      for (let k = 0; k < this.abc.length; k++) {
        if (this.abc[k].MyCate == true) {
          this.inforText = '是否现在交卷？';
        } else {
          this.inforText = '有试题未完成，是否现在交卷？';
        }
      }
    },
    //进度条变化
    Progress() {
      let res = [];
      let res2 = [];
      res = res.concat(
        this.abc.map((c) => {
          if (c.MyCate == true) {
            res2.push(c.Status);
          }
          return c.Status;
        })
      );
      this.zongjindu = res.length;
      this.jindu = res2.length;
    },
    getList() {
      let para = {
        // pagerId: this.paperId,
        examId: this.Id,
      };

      SelectPaperQuestion(para).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].answer = JSON.parse(res.data[i].answer);
          res.data[i].bjStatus = false;
          res.data[i].MyCate = false;
          
          res.data[i].value = '';
          res.data[i].CheckAnswer = [];
          res.data[i].visible = false;
          if (res.data[i].type == 1) {
            this.dxt += 1;
            this.dxtSum += res.data[i].score;
          } else if (res.data[i].type == 2) {
            this.ddxt += 1;
            this.ddxtSum += res.data[i].score;
          } else if (res.data[i].type == 3) {
            
            this.pdt += 1;
            this.pdtSum += res.data[i].score;
          } else if (res.data[i].type == 5) {
            for (let index = 0; index < res.data[i].answer.length; index++) {
              res.data[i].answer[index].letter = '';
            }
            this.wdt += 1;
            this.wdtSum += res.data[i].score;
          } else if (res.data[i].type == 4) {
            this.tkt += 1;
            this.tktSum += res.data[i].score;
            for (let index = 0; index < res.data[i].answer.length; index++) {
              res.data[i].answer[index].letter = '';
            }
          } else if (res.data[i].type == 6) {
            this.sct += 1;
            this.sctSum += res.data[i].score;
          }
        }
        //处理随机题目
     
        sessionStorage.removeItem('tijiao');
        this.abc = res.data;
        // console.log(this.abc)
        this.questionList=JSON.stringify(res.data)
        this.loading = false;
        this.allSum = this.abc.length;
      });
    },
    radioChange(index, indexs, item) {
      this.abc[index].answer.map((v, i) => {
        if (i == indexs) {
          v.IsCheck = true;
          this.abc[index].MyCate = true;
          
          this.$refs.left.Selected(index, indexs, item);
          this.abc[index].CheckAnswer = {
            QuestionId: item.id,
            Value: indexs + 1,
          };
        } else {
          v.IsCheck = false;
          this.abc[index].MyCate = true;
          this.$refs.left.Selected(index, indexs, item);
          this.abc[index].CheckAnswer = {
            QuestionId: item.id,
            Value: indexs + 1,
          };
        }
      });
      this.Progress();
    },
    checkboxChange(index, indexs, item) {
      if (this.abc[index].answer[indexs].IsCheck == true) {
        this.abc[index].MyCate = true;
        this.$refs.left.Selected(index, indexs, item);
        this.abc[index].CheckAnswer.push({
          QuestionId: item.id,
          Value: indexs + 1,
        });
      } else if (this.abc[index].answer[indexs].IsCheck == false) {
        this.abc[index].CheckAnswer.splice(0, 1);
      }
      if (this.abc[index].CheckAnswer.length == 0) {
        this.abc[index].MyCate = false;
        this.$refs.left.Selected(index, indexs, item);
      }
      this.Progress();
    },
    dui(index, item) {
      this.abc[index].answer[0].IsCheck = true;
      this.abc[index].CheckAnswer = { QuestionId: item.id, Value: 'true' };
      this.abc[index].MyCate = true;
      this.Progress();
      this.$refs.left.Selected(index, 0, item);
    },
    cuo(index, item) {
      this.abc[index].answer[0].IsCheck = false;
      this.abc[index].CheckAnswer = { QuestionId: item.id, Value: 'false' };
      this.abc[index].MyCate = true;
      this.Progress();
      this.$refs.left.Selected(index, 0, item);
    },
    inputChange(index, indexs, item) {
      for (let i = 0; i < this.abc[index].answer.length; i++) {
        if (this.abc[index].answer[i].letter != '') {
          this.abc[index].MyCate = true;
          this.$refs.left.Selected(index, indexs, item);
          break;
        } else if (this.abc[index].answer[i].letter == '') {
          this.abc[index].MyCate = false;
          this.$refs.left.Selected(index, indexs, item);
        }
      }
      
      this.Progress();
    },
    biaoji(item, index) {
      if (item.bjStatus == 0) {
        item.bjStatus = true;
        this.$refs.left.bj(item, index);
        this.$message({
          type: 'success',
          message: '已标记!',
        });
      } else {
        item.bjStatus = false;
        this.$refs.left.bj(item, index);
        this.$message({
          type: 'success',
          message: '取消标记!',
        });
      }
    },
    //动画加载,提交后显示分数
    loadings() {
      let _this = this;
      this.show = true;
      if (this.percentage != 100) {
        // this.loading = true;
        var s = setInterval(() => {
          this.percentage += 10;
          if (this.percentage == 100) {
            clearInterval(s);
            this.show = false;
            this.percentage = 0;
            setTimeout(() => {
              let allscore = 0;
              let res = [];
              for (let i = 0; i < this.abc.length; i++) {
                if (this.abc[i].CheckAnswer.length == 0) {
                  this.abc[i].CheckAnswer = { QuestionId: 0, Value: 0 };
                }
                res.push(this.abc[i].CheckAnswer);
              }
              //提交试卷到后台
              Exam.SubmitExam(
                _this.Id,
                _this.userId,
                _this.enterPaperId,
                parseFloat(allscore),
                false,
                _this.abc
              ).then((res) => {
                if (res.code == 200) {
                  _this.$message.success('提交成功!');
                  this.totalScore=res.result;
                  sessionStorage.setItem('tijiao', true);
                  localStorage.removeItem('oldtimes');
                  this.submitDialogVisible = false;
                  this.dialogVisible1 = true;
                  // this.$router.replace({
                  //   path: '/subMulationExam',
                  //   query: { score: allscore },
                  // });
                }
              });
            }, 1000);
          }
        }, 50);
      }
    },
    //主动提交
    Submit() {
      this.loadings();
      this.submitDialogVisible = false;
    },
    //查询试卷信息
    getpaper() {
      let para = {
        id: this.paperId,
      };
      SelectPaperDetail(para).then((res) => {
        this.PaperDetail = res.result;
      });
    },
    //查询考试信息
    getexam() {
      let para = {
        id: this.Id,
      };
      GetDetailLx(para).then((res) => {
        this.ExamDetail = res.result;
        // this.paperTime();
      });
    },
    //进入考试页面
    getEnterPaperId() {
      let para = {
        examId: parseInt(this.Id),
        createId: this.userId,
      };

      EnterPaper(para).then((res) => {
        this.enterPaperId = res.result;
        if (res.code == 200) {
          this.$message({
            message: '请开始作答',
            type: 'success',
          });
        } else {
          this.$message.error('服务器故障，请稍后重试');
        }
      });
    },
  },
  created() {
    sessionStorage.removeItem('tijiao');
    if (this.$store.state.User.tokens) {
      this.temp.createId = JSON.parse(getInfo('infos')).id;
      this.userName = JSON.parse(getInfo('infos')).name;
      this.deptName = JSON.parse(getInfo('infos')).deptName;
      this.userId = JSON.parse(getInfo('infos')).id;
      // this.getCateList();
    }
    this.getEnterPaperId();
    //左悬浮div吸顶
    window.onscroll = () => {
      var scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      if (scrollTop >= 418) {
        this.fix = true;
      } else if (scrollTop < 418) {
        this.fix = false;
      }
    };
    this.getList();
    this.getexam();
    // this.getpaper();
  },
  mounted() {
    if (this.Status == true) {
      for (let i = 0; i < this.abc.length; i++) {
        for (let j = 0; j < this.abc[i].answer.length; j++) {
          if (this.abc[i].answer[j].IsRight) {
            this.abc[i].value = this.abc[i].answer[j].Id;
          }
        }
      }
    }
  },
  watch: {
    dialogVisible: {
      handler() {
        if (this.dialogVisible == false) {
          clearInterval(this.timer);
        }
      },
    },
    abc: {
      // 深度监听
      handler(val, oldVal) {
        let myCateList = 0;
        this.abc.forEach((item) => {
          if (item.MyCate) {
            myCateList++;
          }
        });
        this.speedNum = myCateList;
        this.paperPercentage = parseInt(100 * (this.speedNum / this.allSum));
      },
      deep: true,
    },
  },
  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
@import url('../../../assets/font_81dv624ewpl/iconfont.css');
.subject >>>p{
  padding: 0;
  margin: 0 !important;
}
.container {
  width: 100%;
}
.zhuti {
  width: 50%;
  background-color: white;
  margin-top: 20px;
  margin-left: 30%;
  /* border-bottom: 1px solid rgb(226, 223, 223); */
  border-left: 1px solid #f2f2f2;
  border-right: 1px solid #f2f2f2;
  border-radius: 5px;
  margin-bottom: 30px;
  /* height: 720px; */
  overflow: auto;
  min-height: 700px;
}
.title {
  width: 100%;
  height: 40px;
  padding-top: 15px;
  font-size: 20px;
  font-weight: bold;
  background-color: #f2f2f2;
  /* border-left: 1px dashed rgb(226, 223, 223);
  border-right: 1px dashed rgb(226, 223, 223); */
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-top: 1px dashed rgb(226, 223, 223);
}
li {
  padding-left: 40px;
  list-style: none;
  font-size: 30px;
  /* padding-bottom: 10px; */
}
.leftzj {
  position: absolute;
  left: 12%;
  top: 180px;
  height: 73vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.fixed {
  position: fixed;
  left: 12%;
  top: 20px;
  height: 73vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.tj {
  padding: 10px;
}

.paper-fixed {
  display: flex;
  flex-direction: column;
  width: 120px;
  height: 240px;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  text-align: center;
  padding: 10px 0;
  position: fixed;
  right: 167px;
  top: 20px;
}
.icon {
  width: 1em;
  height: 1em;
  font-size: 20px;
}
.icons {
  width: 1em;
  height: 1em;
  font-size: 15px;
}
.bj {
  background-color: #1a8cfe;
}
.sss {
  display: flex;
  /* flex-flow: row nowrap; */
  justify-content: space-between;
  margin-left: 20px;
  margin-right: 20px;
}
.hhh {
  /* border: 1px solid rgb(226, 223, 223); */
  /* margin-top: 20px; */
  margin-bottom: 20px;
  padding-top: 20px;
}
.answer {
  display: flex;
  width: 92%;
  margin-left: 4%;
  border-top: 1px dashed rgb(226, 223, 223);
  line-height: 40px;
}
.analysis {
  width: 92%;
  margin-left: 4%;
  border-top: 1px dashed rgb(226, 223, 223);
  line-height: 40px;
}
.mychange {
  display: flex;
  width: 150px;
}
.rightanswer {
  display: flex;
  width: 150px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.progress {
  z-index: 2000;
  text-align: center;
  position: fixed;
  left: 39.5%;
  top: 35%;
  height: 250px;
  width: 400px;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  background-color: #fafafa;
}
.subject {
  display: flex;
  width: 95%;
  align-items: baseline;
  font-size: 18px;
}
.padding-r5 {
  padding-right: 5px;
  font-size: 16px;
}
.xz-label {
  font-size: 16px;
  padding: 7px 0;
  display: flex;
  width: 92%;
  align-items: baseline;
}
.xz-label:hover {
  background-color: whitesmoke;
}
.paper-time {
  width: 120px;
  height: 50px;
  line-height: 25px;
  border-bottom: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  text-align: center;
  padding: 10px 0;
}
.red-color {
  color: red;
  font-size: 18px;
}
.paper-box {
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 167px;
  top: 180px;
  width: 120px;
  height: 240px;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  text-align: center;
  padding: 10px 0;
}
.paper-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 30px;
  height: 80px;
  border-bottom: 1px solid rgb(226, 223, 223);
  padding: 10px 0;
}
.speed {
  padding: 0 5px;
}
.iconfont {
  color: #409eff;
}
.goscExam {
  margin: 10px 20px;
  display: flex;
  flex-direction: column;
  line-height: 40px;
  align-items: center;
}
.rules-box {
  display: flex;
  margin-top: 20px;
}
.select-box {
  margin-top: 15px;
}
.rules-text {
  padding-left: 30px;
}
@media (max-width: 1366px) {
  .leftzj {
    position: absolute;
    left: 9%;
    top: 180px;
    overflow-y: auto;
    height: 73vh;
    overflow-x: hidden;
  }
  .fixed {
    position: fixed;
    left: 9%;
    top: 20px;
    overflow-y: auto;
    height: 73vh;
    overflow-x: hidden;
  }
  .paper-box {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 10%;
    top: 180px;
    width: 120px;
    height: 240px;
    font-size: 14px;
    font-weight: 400;
    border: 1px solid rgb(226, 223, 223);
    border-radius: 5px;
    text-align: center;
    padding: 10px 0;
  }
  .paper-fixed {
    display: flex;
    flex-direction: column;
    width: 120px;
    height: 240px;
    font-size: 14px;
    font-weight: 400;
    border: 1px solid rgb(226, 223, 223);
    border-radius: 5px;
    text-align: center;
    padding: 10px 0;
    position: fixed;
    right: 10%;
    top: 20px;
  }
}
@media (max-width: 1680px) {
  .leftzj {
    position: absolute;
    left: 10%;
    top: 180px;
    overflow-y: auto;
    height: 73vh;
    overflow-x: hidden;
  }
  .fixed {
    position: fixed;
    left: 10%;
    top: 20px;
    overflow-y: auto;
    height: 73vh;
    overflow-x: hidden;
  }
  .paper-box {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 10%;
    top: 180px;
    width: 120px;
    height: 240px;
    font-size: 14px;
    font-weight: 400;
    border: 1px solid rgb(226, 223, 223);
    border-radius: 5px;
    text-align: center;
    padding: 10px 0;
  }
  .paper-fixed {
    display: flex;
    flex-direction: column;
    width: 120px;
    height: 240px;
    font-size: 14px;
    font-weight: 400;
    border: 1px solid rgb(226, 223, 223);
    border-radius: 5px;
    text-align: center;
    padding: 10px 0;
    position: fixed;
    right: 10%;
    top: 20px;
  }
}
.el-icon-question,
.icon-qizi-copy {
  cursor: pointer;
}
.title-info {
  display: flex;
  margin-top: 10px;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
}
.test-description {
  width: 50%;
  margin: 0 auto;
  margin-left: 30%;
  margin-top: 20px;
  line-height: 25px;
  font-size: 15px;
  /* text-indent: 2em; */
}
</style>
<style lang="scss" scoped>
.cheat-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .cheat-title {
    padding: 10px 0;
    font-size: 18px;
    font-weight: 700;
    border-bottom: 1px solid #80808029;
    width: 100%;
    text-align: center;
  }
  .cheat-container {
    height: 120px;
    width: 100%;
    border-bottom: 1px solid #80808029;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .cheat-num {
      width: 80px;
      height: 80px;
      border: 2px solid #808080bf;
      border-radius: 50%;
      text-align: center;
      line-height: 80px;
      font-weight: 700;
      color: #808080bf;
      font-size: 20px;
      margin-bottom: 40px;
    }
    .cheat-beizhu-weight {
      font-weight: 700;
      font-size: 30px;
    }
  }
  .cheat-button {
    margin-top: 20px;
  }
}
</style>